export default [
  {
    capitalInfo: {
      latlng: [
        33.5,
        36.3,
      ],
    },
    cca2: 'SY',
    capital: [
      'Damascus',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -41.3,
        174.78,
      ],
    },
    cca2: 'NZ',
    capital: [
      'Wellington',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        4.88,
        114.93,
      ],
    },
    cca2: 'BN',
    capital: [
      'Bandar Seri Begawan',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -7.3,
        72.4,
      ],
    },
    cca2: 'IO',
    capital: [
      'Diego Garcia',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -1.28,
        36.82,
      ],
    },
    cca2: 'KE',
    capital: [
      'Nairobi',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        7.5,
        134.62,
      ],
    },
    cca2: 'PW',
    capital: [
      'Ngerulmud',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        23.62,
        58.58,
      ],
    },
    cca2: 'OM',
    capital: [
      'Muscat',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        19.43,
        -99.13,
      ],
    },
    cca2: 'MX',
    capital: [
      'Mexico City',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        31.9,
        35.2,
      ],
    },
    cca2: 'PS',
    capital: [
      'Ramallah',
      'Jerusalem',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        21.46,
        -71.14,
      ],
    },
    cca2: 'TC',
    capital: [
      'Cockburn Town',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        4.37,
        18.58,
      ],
    },
    cca2: 'CF',
    capital: [
      'Bangui',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        17.3,
        -62.72,
      ],
    },
    cca2: 'KN',
    capital: [
      'Basseterre',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        4.85,
        31.62,
      ],
    },
    cca2: 'SS',
    capital: [
      'Juba',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        50.43,
        30.52,
      ],
    },
    cca2: 'UA',
    capital: [
      'Kyiv',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        17.88,
        -62.85,
      ],
    },
    cca2: 'BL',
    capital: [
      'Gustavia',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        52.35,
        4.92,
      ],
    },
    cca2: 'NL',
    capital: [
      'Amsterdam',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -6.16,
        35.75,
      ],
    },
    cca2: 'TZ',
    capital: [
      'Dodoma',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        50.08,
        14.47,
      ],
    },
    cca2: 'CZ',
    capital: [
      'Prague',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        53.9,
        27.57,
      ],
    },
    cca2: 'BY',
    capital: [
      'Minsk',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        15.37,
        44.19,
      ],
    },
    cca2: 'YE',
    capital: [
      "Sana'a",
    ],
  },
  {
    capitalInfo: {
      latlng: [
        46.05,
        14.52,
      ],
    },
    cca2: 'SI',
    capital: [
      'Ljubljana',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -9.38,
        -171.22,
      ],
    },
    cca2: 'TK',
    capital: [
      'Fakaofo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        9.08,
        7.53,
      ],
    },
    cca2: 'NG',
    capital: [
      'Abuja',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -20.88,
        55.45,
      ],
    },
    cca2: 'RE',
    capital: [
      'Saint-Denis',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        16.03,
        -61.73,
      ],
    },
    cca2: 'GP',
    capital: [
      'Basse-Terre',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        47.5,
        19.08,
      ],
    },
    cca2: 'HU',
    capital: [
      'Budapest',
    ],
  },
  {
    capitalInfo: {
      latlng: [],
    },
    cca2: 'HM',
    capital: [],
  },
  {
    capitalInfo: {
      latlng: [
        -26.32,
        31.13,
      ],
    },
    cca2: 'SZ',
    capital: [
      'Mbabane',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -11.7,
        43.23,
      ],
    },
    cca2: 'KM',
    capital: [
      'Moroni',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        28.6,
        77.2,
      ],
    },
    cca2: 'IN',
    capital: [
      'New Delhi',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -12.17,
        96.83,
      ],
    },
    cca2: 'CC',
    capital: [
      'West Island',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        51.5,
        -0.08,
      ],
    },
    cca2: 'GB',
    capital: [
      'London',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -8.83,
        13.22,
      ],
    },
    cca2: 'AO',
    capital: [
      'Luanda',
    ],
  },
  {
    capitalInfo: {
      latlng: [],
    },
    cca2: 'MO',
    capital: [],
  },
  {
    capitalInfo: {
      latlng: [
        9.93,
        -84.09,
      ],
    },
    cca2: 'CR',
    capital: [
      'San José',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -19.02,
        -169.92,
      ],
    },
    cca2: 'NU',
    capital: [
      'Alofi',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -21.2,
        -159.77,
      ],
    },
    cca2: 'CK',
    capital: [
      'Avarua',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        11.58,
        43.15,
      ],
    },
    cca2: 'DJ',
    capital: [
      'Djibouti',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        46.77,
        -56.18,
      ],
    },
    cca2: 'PM',
    capital: [
      'Saint-Pierre',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        48.2,
        16.37,
      ],
    },
    cca2: 'AT',
    capital: [
      'Vienna',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -6.17,
        106.82,
      ],
    },
    cca2: 'ID',
    capital: [
      'Jakarta',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -0.55,
        166.92,
      ],
    },
    cca2: 'NR',
    capital: [
      'Yaren',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        51.16,
        71.45,
      ],
    },
    cca2: 'KZ',
    capital: [
      'Astana',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -13.97,
        33.78,
      ],
    },
    cca2: 'MW',
    capital: [
      'Lilongwe',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        15.33,
        38.93,
      ],
    },
    cca2: 'ER',
    capital: [
      'Asmara',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        36.8,
        10.18,
      ],
    },
    cca2: 'TN',
    capital: [
      'Tunis',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -25.07,
        -130.08,
      ],
    },
    cca2: 'PN',
    capital: [
      'Adamstown',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        24.65,
        46.7,
      ],
    },
    cca2: 'SA',
    capital: [
      'Riyadh',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        37.95,
        58.38,
      ],
    },
    cca2: 'TM',
    capital: [
      'Ashgabat',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -13.28,
        27.14,
      ],
    },
    cca2: 'EH',
    capital: [
      'El Aaiún',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        5.55,
        -0.22,
      ],
    },
    cca2: 'GH',
    capital: [
      'Accra',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -8.52,
        179.22,
      ],
    },
    cca2: 'TV',
    capital: [
      'Funafuti',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        19.76,
        96.07,
      ],
    },
    cca2: 'MM',
    capital: [
      'Naypyidaw',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        0.38,
        9.45,
      ],
    },
    cca2: 'GA',
    capital: [
      'Libreville',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        23.12,
        -82.35,
      ],
    },
    cca2: 'CU',
    capital: [
      'Havana',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        39.92,
        116.38,
      ],
    },
    cca2: 'CN',
    capital: [
      'Beijing',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        8.97,
        -79.53,
      ],
    },
    cca2: 'PA',
    capital: [
      'Panama City',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        13.75,
        100.52,
      ],
    },
    cca2: 'TH',
    capital: [
      'Bangkok',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        55.75,
        37.6,
      ],
    },
    cca2: 'RU',
    capital: [
      'Moscow',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        43.87,
        18.42,
      ],
    },
    cca2: 'BA',
    capital: [
      'Sarajevo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        25.28,
        51.53,
      ],
    },
    cca2: 'QA',
    capital: [
      'Doha',
    ],
  },
  {
    capitalInfo: {
      latlng: [],
    },
    cca2: 'BV',
    capital: [],
  },
  {
    capitalInfo: {
      latlng: [
        33.33,
        44.4,
      ],
    },
    cca2: 'IQ',
    capital: [
      'Baghdad',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        38.55,
        68.77,
      ],
    },
    cca2: 'TJ',
    capital: [
      'Dushanbe',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        6.8,
        -58.15,
      ],
    },
    cca2: 'GY',
    capital: [
      'Georgetown',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -9.43,
        159.95,
      ],
    },
    cca2: 'SB',
    capital: [
      'Honiara',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        48.15,
        17.12,
      ],
    },
    cca2: 'SK',
    capital: [
      'Bratislava',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        36.13,
        -5.35,
      ],
    },
    cca2: 'GI',
    capital: [
      'Gibraltar',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -12.05,
        -77.05,
      ],
    },
    cca2: 'PE',
    capital: [
      'Lima',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.47,
        -66.12,
      ],
    },
    cca2: 'PR',
    capital: [
      'San Juan',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        40.17,
        44.5,
      ],
    },
    cca2: 'AM',
    capital: [
      'Yerevan',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        40.38,
        49.87,
      ],
    },
    cca2: 'AZ',
    capital: [
      'Baku',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.07,
        -15.97,
      ],
    },
    cca2: 'MR',
    capital: [
      'Nouakchott',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        17.25,
        -88.77,
      ],
    },
    cca2: 'BZ',
    capital: [
      'Belmopan',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.22,
        -63.05,
      ],
    },
    cca2: 'AI',
    capital: [
      'The Valley',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -4.62,
        55.45,
      ],
    },
    cca2: 'SC',
    capital: [
      'Victoria',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -29.05,
        167.97,
      ],
    },
    cca2: 'NF',
    capital: [
      'Kingston',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        14.6,
        120.97,
      ],
    },
    cca2: 'PH',
    capital: [
      'Manila',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -34.58,
        -58.67,
      ],
    },
    cca2: 'AR',
    capital: [
      'Buenos Aires',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        47.01,
        28.9,
      ],
    },
    cca2: 'MD',
    capital: [
      'Chișinău',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -13.82,
        -171.77,
      ],
    },
    cca2: 'WS',
    capital: [
      'Apia',
    ],
  },
  {
    capitalInfo: {
      latlng: [],
    },
    cca2: 'AQ',
    capital: [],
  },
  {
    capitalInfo: {
      latlng: [
        8.48,
        -13.23,
      ],
    },
    cca2: 'SL',
    capital: [
      'Freetown',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        11.55,
        104.92,
      ],
    },
    cca2: 'KH',
    capital: [
      'Phnom Penh',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -17.73,
        168.32,
      ],
    },
    cca2: 'VU',
    capital: [
      'Port Vila',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        31.95,
        35.93,
      ],
    },
    cca2: 'JO',
    capital: [
      'Amman',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        14.6,
        -61.08,
      ],
    },
    cca2: 'MQ',
    capital: [
      'Fort-de-France',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -21.13,
        -175.2,
      ],
    },
    cca2: 'TO',
    capital: [
      "Nuku'alofa",
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.42,
        -64.62,
      ],
    },
    cca2: 'VG',
    capital: [
      'Road Town',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -8.58,
        125.6,
      ],
    },
    cca2: 'TL',
    capital: [
      'Dili',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -17.53,
        -149.56,
      ],
    },
    cca2: 'PF',
    capital: [
      'Papeetē',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        39.93,
        32.87,
      ],
    },
    cca2: 'TR',
    capital: [
      'Ankara',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        49.45,
        -2.54,
      ],
    },
    cca2: 'GG',
    capital: [
      'St. Peter Port',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        14.73,
        -17.63,
      ],
    },
    cca2: 'SN',
    capital: [
      'Dakar',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        14.62,
        -90.52,
      ],
    },
    cca2: 'GT',
    capital: [
      'Guatemala City',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        52.25,
        21.0,
      ],
    },
    cca2: 'PL',
    capital: [
      'Warsaw',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        25.08,
        -77.35,
      ],
    },
    cca2: 'BS',
    capital: [
      'Nassau',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        62.01,
        -6.77,
      ],
    },
    cca2: 'FO',
    capital: [
      'Tórshavn',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        12.52,
        -70.03,
      ],
    },
    cca2: 'AW',
    capital: [
      'Oranjestad',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.47,
        -69.9,
      ],
    },
    cca2: 'DO',
    capital: [
      'Santo Domingo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        22.267,
        114.188,
      ],
    },
    cca2: 'HK',
    capital: [
      'City of Victoria',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        0.34,
        6.73,
      ],
    },
    cca2: 'ST',
    capital: [
      'São Tomé',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -34.85,
        -56.17,
      ],
    },
    cca2: 'UY',
    capital: [
      'Montevideo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        32.28,
        -64.78,
      ],
    },
    cca2: 'BM',
    capital: [
      'Hamilton',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -13.95,
        -171.93,
      ],
    },
    cca2: 'WF',
    capital: [
      'Mata-Utu',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -25.7,
        28.22,
      ],
    },
    cca2: 'ZA',
    capital: [
      'Pretoria',
      'Bloemfontein',
      'Cape Town',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        31.77,
        35.23,
      ],
    },
    cca2: 'IL',
    capital: [
      'Jerusalem',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        43.94,
        12.45,
      ],
    },
    cca2: 'SM',
    capital: [
      'City of San Marino',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        13.7,
        -89.2,
      ],
    },
    cca2: 'SV',
    capital: [
      'San Salvador',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        47.92,
        106.91,
      ],
    },
    cca2: 'MN',
    capital: [
      'Ulan Bator',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -14.27,
        -170.7,
      ],
    },
    cca2: 'AS',
    capital: [
      'Pago Pago',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        48.81,
        -1.4,
      ],
    },
    cca2: 'TF',
    capital: [
      'Port-aux-Français',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -17.82,
        31.03,
      ],
    },
    cca2: 'ZW',
    capital: [
      'Harare',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -51.7,
        -57.85,
      ],
    },
    cca2: 'FK',
    capital: [
      'Stanley',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        45.8,
        16.0,
      ],
    },
    cca2: 'HR',
    capital: [
      'Zagreb',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        1.33,
        172.98,
      ],
    },
    cca2: 'KI',
    capital: [
      'South Tarawa',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        7.1,
        171.38,
      ],
    },
    cca2: 'MH',
    capital: [
      'Majuro',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        59.92,
        10.75,
      ],
    },
    cca2: 'NO',
    capital: [
      'Oslo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        12.65,
        -8.0,
      ],
    },
    cca2: 'ML',
    capital: [
      'Bamako',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -15.42,
        28.28,
      ],
    },
    cca2: 'ZM',
    capital: [
      'Lusaka',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        4.17,
        73.51,
      ],
    },
    cca2: 'MV',
    capital: [
      'Malé',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        17.12,
        -61.85,
      ],
    },
    cca2: 'AG',
    capital: [
      "Saint John's",
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -10.42,
        105.68,
      ],
    },
    cca2: 'CX',
    capital: [
      'Flying Fish Cove',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        35.7,
        51.42,
      ],
    },
    cca2: 'IR',
    capital: [
      'Tehran',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        41.9,
        12.48,
      ],
    },
    cca2: 'IT',
    capital: [
      'Rome',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        13.45,
        -16.57,
      ],
    },
    cca2: 'GM',
    capital: [
      'Banjul',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        37.55,
        126.98,
      ],
    },
    cca2: 'KR',
    capital: [
      'Seoul',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -9.45,
        147.18,
      ],
    },
    cca2: 'PG',
    capital: [
      'Port Moresby',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        30.05,
        31.25,
      ],
    },
    cca2: 'EG',
    capital: [
      'Cairo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        54.15,
        -4.48,
      ],
    },
    cca2: 'IM',
    capital: [
      'Douglas',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        56.95,
        24.1,
      ],
    },
    cca2: 'LV',
    capital: [
      'Riga',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -25.28,
        -57.57,
      ],
    },
    cca2: 'PY',
    capital: [
      'Asunción',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        32.38,
        -64.68,
      ],
    },
    cca2: 'GD',
    capital: [
      "St. George's",
    ],
  },
  {
    capitalInfo: {
      latlng: [
        4.71,
        -74.07,
      ],
    },
    cca2: 'CO',
    capital: [
      'Bogotá',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        60.17,
        24.93,
      ],
    },
    cca2: 'FI',
    capital: [
      'Helsinki',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        42.68,
        23.32,
      ],
    },
    cca2: 'BG',
    capital: [
      'Sofia',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        6.14,
        1.21,
      ],
    },
    cca2: 'TG',
    capital: [
      'Lomé',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -33.45,
        -70.67,
      ],
    },
    cca2: 'CL',
    capital: [
      'Santiago',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        15.3,
        -61.4,
      ],
    },
    cca2: 'DM',
    capital: [
      'Roseau',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        53.32,
        -6.23,
      ],
    },
    cca2: 'IE',
    capital: [
      'Dublin',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -24.63,
        25.9,
      ],
    },
    cca2: 'BW',
    capital: [
      'Gaborone',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        42.67,
        21.17,
      ],
    },
    cca2: 'XK',
    capital: [
      'Pristina',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        38.89,
        -77.05,
      ],
    },
    cca2: 'US',
    capital: [
      'Washington, D.C.',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        41.32,
        69.25,
      ],
    },
    cca2: 'UZ',
    capital: [
      'Tashkent',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -15.79,
        -47.88,
      ],
    },
    cca2: 'BR',
    capital: [
      'Brasília',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -1.95,
        30.05,
      ],
    },
    cca2: 'RW',
    capital: [
      'Kigali',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        47.13,
        9.52,
      ],
    },
    cca2: 'LI',
    capital: [
      'Vaduz',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        27.47,
        89.63,
      ],
    },
    cca2: 'BT',
    capital: [
      'Thimphu',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        42.43,
        19.27,
      ],
    },
    cca2: 'ME',
    capital: [
      'Podgorica',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        13.52,
        2.12,
      ],
    },
    cca2: 'NE',
    capital: [
      'Niamey',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        41.32,
        19.82,
      ],
    },
    cca2: 'AL',
    capital: [
      'Tirana',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        34.02,
        -6.82,
      ],
    },
    cca2: 'MA',
    capital: [
      'Rabat',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        10.48,
        -66.87,
      ],
    },
    cca2: 'VE',
    capital: [
      'Caracas',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -4.25,
        15.28,
      ],
    },
    cca2: 'CG',
    capital: [
      'Brazzaville',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -3.43,
        29.93,
      ],
    },
    cca2: 'BI',
    capital: [
      'Gitega',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        49.18,
        -2.1,
      ],
    },
    cca2: 'JE',
    capital: [
      'Saint Helier',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        42.0,
        21.43,
      ],
    },
    cca2: 'MK',
    capital: [
      'Skopje',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        42.87,
        74.6,
      ],
    },
    cca2: 'KG',
    capital: [
      'Bishkek',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        44.43,
        26.1,
      ],
    },
    cca2: 'RO',
    capital: [
      'Bucharest',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        13.48,
        144.75,
      ],
    },
    cca2: 'GU',
    capital: [
      'Hagåtña',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        60.12,
        19.9,
      ],
    },
    cca2: 'AX',
    capital: [
      'Mariehamn',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        3.75,
        8.78,
      ],
    },
    cca2: 'GQ',
    capital: [
      'Malabo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -54.28,
        -36.5,
      ],
    },
    cca2: 'GS',
    capital: [
      'King Edward Point',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        4.94,
        -52.33,
      ],
    },
    cca2: 'GF',
    capital: [
      'Cayenne',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        52.52,
        13.4,
      ],
    },
    cca2: 'DE',
    capital: [
      'Berlin',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        55.67,
        12.58,
      ],
    },
    cca2: 'DK',
    capital: [
      'Copenhagen',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        64.15,
        -21.95,
      ],
    },
    cca2: 'IS',
    capital: [
      'Reykjavik',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        2.07,
        45.33,
      ],
    },
    cca2: 'SO',
    capital: [
      'Mogadishu',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        6.92,
        158.15,
      ],
    },
    cca2: 'FM',
    capital: [
      'Palikir',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        17.97,
        102.6,
      ],
    },
    cca2: 'LA',
    capital: [
      'Vientiane',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.02,
        -63.03,
      ],
    },
    cca2: 'SX',
    capital: [
      'Philipsburg',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        6.3,
        -10.8,
      ],
    },
    cca2: 'LR',
    capital: [
      'Monrovia',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        12.1,
        15.03,
      ],
    },
    cca2: 'TD',
    capital: [
      "N'Djamena",
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -35.27,
        149.13,
      ],
    },
    cca2: 'AU',
    capital: [
      'Canberra',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        12.37,
        -1.52,
      ],
    },
    cca2: 'BF',
    capital: [
      'Ouagadougou',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        35.88,
        14.5,
      ],
    },
    cca2: 'MT',
    capital: [
      'Valletta',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        15.2,
        145.75,
      ],
    },
    cca2: 'MP',
    capital: [
      'Saipan',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        0.32,
        32.55,
      ],
    },
    cca2: 'UG',
    capital: [
      'Kampala',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        40.4,
        -3.68,
      ],
    },
    cca2: 'ES',
    capital: [
      'Madrid',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        15.6,
        32.53,
      ],
    },
    cca2: 'SD',
    capital: [
      'Khartoum',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        25.03,
        121.52,
      ],
    },
    cca2: 'TW',
    capital: [
      'Taipei',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        34.52,
        69.18,
      ],
    },
    cca2: 'AF',
    capital: [
      'Kabul',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        78.22,
        15.63,
      ],
    },
    cca2: 'SJ',
    capital: [
      'Longyearbyen',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -18.13,
        178.42,
      ],
    },
    cca2: 'FJ',
    capital: [
      'Suva',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        11.85,
        -15.58,
      ],
    },
    cca2: 'GW',
    capital: [
      'Bissau',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        42.5,
        1.52,
      ],
    },
    cca2: 'AD',
    capital: [
      'Andorra la Vella',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        36.75,
        3.05,
      ],
    },
    cca2: 'DZ',
    capital: [
      'Algiers',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        38.72,
        -9.13,
      ],
    },
    cca2: 'PT',
    capital: [
      'Lisbon',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -25.95,
        32.58,
      ],
    },
    cca2: 'MZ',
    capital: [
      'Maputo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -29.32,
        27.48,
      ],
    },
    cca2: 'LS',
    capital: [
      'Maseru',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        39.02,
        125.75,
      ],
    },
    cca2: 'KP',
    capital: [
      'Pyongyang',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        1.28,
        103.85,
      ],
    },
    cca2: 'SG',
    capital: [
      'Singapore',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        43.73,
        7.42,
      ],
    },
    cca2: 'MC',
    capital: [
      'Monaco',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        33.87,
        35.5,
      ],
    },
    cca2: 'LB',
    capital: [
      'Beirut',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        44.83,
        20.5,
      ],
    },
    cca2: 'RS',
    capital: [
      'Belgrade',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        59.43,
        24.72,
      ],
    },
    cca2: 'EE',
    capital: [
      'Tallinn',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        13.1,
        -59.62,
      ],
    },
    cca2: 'BB',
    capital: [
      'Bridgetown',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -20.15,
        57.48,
      ],
    },
    cca2: 'MU',
    capital: [
      'Port Louis',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -15.93,
        -5.72,
      ],
    },
    cca2: 'SH',
    capital: [
      'Jamestown',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        50.83,
        4.33,
      ],
    },
    cca2: 'BE',
    capital: [
      'Brussels',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        32.88,
        13.17,
      ],
    },
    cca2: 'LY',
    capital: [
      'Tripoli',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        12.13,
        -86.25,
      ],
    },
    cca2: 'NI',
    capital: [
      'Managua',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        29.37,
        47.97,
      ],
    },
    cca2: 'KW',
    capital: [
      'Kuwait City',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -22.27,
        166.45,
      ],
    },
    cca2: 'NC',
    capital: [
      'Nouméa',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        48.87,
        2.33,
      ],
    },
    cca2: 'FR',
    capital: [
      'Paris',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        21.03,
        105.85,
      ],
    },
    cca2: 'VN',
    capital: [
      'Hanoi',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        13.13,
        -61.22,
      ],
    },
    cca2: 'VC',
    capital: [
      'Kingstown',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        26.23,
        50.57,
      ],
    },
    cca2: 'BH',
    capital: [
      'Manama',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        12.1,
        -68.92,
      ],
    },
    cca2: 'CW',
    capital: [
      'Willemstad',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        23.72,
        90.4,
      ],
    },
    cca2: 'BD',
    capital: [
      'Dhaka',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        6.82,
        -5.27,
      ],
    },
    cca2: 'CI',
    capital: [
      'Yamoussoukro',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -4.32,
        15.3,
      ],
    },
    cca2: 'CD',
    capital: [
      'Kinshasa',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        6.89,
        79.9,
      ],
    },
    cca2: 'LK',
    capital: [
      'Sri Jayawardenepura Kotte',
    ],
  },
  {
    capitalInfo: {
      latlng: [],
    },
    cca2: 'UM',
    capital: [
      'Washington DC',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        12.14,
        -68.27,
      ],
    },
    cca2: 'BQ',
    capital: [
      'Kralendijk',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        27.72,
        85.32,
      ],
    },
    cca2: 'NP',
    capital: [
      'Kathmandu',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -19.02,
        -65.26,
      ],
    },
    cca2: 'BO',
    capital: [
      'Sucre',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -22.57,
        17.08,
      ],
    },
    cca2: 'NA',
    capital: [
      'Windhoek',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.53,
        -72.33,
      ],
    },
    cca2: 'HT',
    capital: [
      'Port-au-Prince',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        5.83,
        -55.17,
      ],
    },
    cca2: 'SR',
    capital: [
      'Paramaribo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.07,
        -63.08,
      ],
    },
    cca2: 'MF',
    capital: [
      'Marigot',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        45.42,
        -75.7,
      ],
    },
    cca2: 'CA',
    capital: [
      'Ottawa',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        14.1,
        -87.22,
      ],
    },
    cca2: 'HN',
    capital: [
      'Tegucigalpa',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        41.9,
        12.45,
      ],
    },
    cca2: 'VA',
    capital: [
      'Vatican City',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        24.47,
        54.37,
      ],
    },
    cca2: 'AE',
    capital: [
      'Abu Dhabi',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        9.5,
        -13.7,
      ],
    },
    cca2: 'GN',
    capital: [
      'Conakry',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        3.85,
        11.5,
      ],
    },
    cca2: 'CM',
    capital: [
      'Yaoundé',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        35.17,
        33.37,
      ],
    },
    cca2: 'CY',
    capital: [
      'Nicosia',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        10.65,
        -61.52,
      ],
    },
    cca2: 'TT',
    capital: [
      'Port of Spain',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        59.33,
        18.05,
      ],
    },
    cca2: 'SE',
    capital: [
      'Stockholm',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -18.92,
        47.52,
      ],
    },
    cca2: 'MG',
    capital: [
      'Antananarivo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -12.78,
        45.22,
      ],
    },
    cca2: 'YT',
    capital: [
      'Mamoudzou',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        19.3,
        -81.38,
      ],
    },
    cca2: 'KY',
    capital: [
      'George Town',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        3.17,
        101.7,
      ],
    },
    cca2: 'MY',
    capital: [
      'Kuala Lumpur',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        6.48,
        2.62,
      ],
    },
    cca2: 'BJ',
    capital: [
      'Porto-Novo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        64.18,
        -51.75,
      ],
    },
    cca2: 'GL',
    capital: [
      'Nuuk',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        46.92,
        7.47,
      ],
    },
    cca2: 'CH',
    capital: [
      'Bern',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        41.68,
        44.83,
      ],
    },
    cca2: 'GE',
    capital: [
      'Tbilisi',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        -0.22,
        -78.5,
      ],
    },
    cca2: 'EC',
    capital: [
      'Quito',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        14.92,
        -23.52,
      ],
    },
    cca2: 'CV',
    capital: [
      'Praia',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        49.6,
        6.12,
      ],
    },
    cca2: 'LU',
    capital: [
      'Luxembourg',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        14.0,
        -61.0,
      ],
    },
    cca2: 'LC',
    capital: [
      'Castries',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        18.35,
        -64.93,
      ],
    },
    cca2: 'VI',
    capital: [
      'Charlotte Amalie',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        35.68,
        139.75,
      ],
    },
    cca2: 'JP',
    capital: [
      'Tokyo',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        17.99702,
        -76.79358,
      ],
    },
    cca2: 'JM',
    capital: [
      'Kingston',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        9.03,
        38.7,
      ],
    },
    cca2: 'ET',
    capital: [
      'Addis Ababa',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        33.68,
        73.05,
      ],
    },
    cca2: 'PK',
    capital: [
      'Islamabad',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        16.7,
        -62.22,
      ],
    },
    cca2: 'MS',
    capital: [
      'Plymouth',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        54.68,
        25.32,
      ],
    },
    cca2: 'LT',
    capital: [
      'Vilnius',
    ],
  },
  {
    capitalInfo: {
      latlng: [
        37.98,
        23.73,
      ],
    },
    cca2: 'GR',
    capital: [
      'Athens',
    ],
  },
];
